module.exports = "\n<multiselect\n  #layerSelect\n  *ngIf=\"layers.length\"\n  [customMultiSelect]=\"displayType === 'largeHeight' ? 'nests' : 'legacy'\"\n  [multiSelectData]=\"{\n              dropdownPxLength: 200,\n              data: layers,\n              resultTemplate: 'layer',\n              formControlName: 'layerForm',\n              placeHolder:  'בחרו שכבה',\n              showInput: false\n\n            }\"\n  class=\"multi-select-nests-input \"\n>\n</multiselect>\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/multi-select-layers/multi-select-layers.component.html
// module id = ./src/app/common/multi-select-layers/multi-select-layers.component.html
// module chunks = main